/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { dimensionInterpolations } from '../utils/UNSAFE_interpolations/dimensions';
import type { DimensionProps } from '../utils/UNSAFE_interpolations/dimensions';
import { mergeInterpolations } from '../utils/UNSAFE_mergeInterpolations';
import { flexitemInterpolations } from '../utils/UNSAFE_interpolations/flexitem';
import type { FlexitemProps } from '../utils/UNSAFE_interpolations/flexitem';

type StyleProps = DimensionProps & Pick<FlexitemProps, 'flex'>;

type Props = StyleProps;

const interpolations = [...Object.values(dimensionInterpolations), flexitemInterpolations.flex];

const styleInterpolations = mergeInterpolations<Props>(interpolations);

export const Spacer = ({ ...props }: Props) => {
  const { class: cls, ...styles } = styleInterpolations(props);
  return <div class={cls} style={styles}></div>;
};
